import { useEffect } from "react"
import * as Yup from "yup"
import { useI18n } from "./"

export default function YupLocale() {
  const { t } = useI18n()

  useEffect(() => {
    Yup.setLocale({
      mixed: {
        default: t("field.validation.mixed.default"),
        required: t("field.validation.mixed.required"),
        oneOf: t("field.validation.mixed.oneOf"),
        notOneOf: t("field.validation.mixed.notOneOf"),
      },
      string: {
        length: t("field.validation.string.length"),
        min: t("field.validation.string.min"),
        max: t("field.validation.string.max"),
        matches: t("field.validation.string.matches"),
        email: t("field.validation.string.email"),
        url: t("field.validation.string.url"),
        trim: t("field.validation.string.trim"),
        lowercase: t("field.validation.string.lowercase"),
        uppercase: t("field.validation.string.uppercase"),
      },
      number: {
        min: t("field.validation.number.min"),
        max: t("field.validation.number.max"),
        lessThan: t("field.validation.number.lessThan"),
        moreThan: t("field.validation.number.moreThan"),
        positive: t("field.validation.number.positive"),
        negative: t("field.validation.number.negative"),
        integer: t("field.validation.number.integer"),
      },
      date: {
        min: t("field.validation.date.min"),
        max: t("field.validation.date.max"),
      },
      object: {
        noUnknown: t("field.validation.object.noUnknown"),
      },
      array: {
        min: t("field.validation.array.min"),
        max: t("field.validation.array.max"),
      },
    })
  }, [t])

  return null
}
